<hyperkit-select
  [options]="options"
  [displayProperty]="'text'"
  [valueProperty]="'id'"
  [(ngModel)]="sort"
  placeholder="Sort by"
  (selectionChange)="onSelect($event)"
></hyperkit-select>
